/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'yesIcon': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M512 64.2c-248.4 0-448.3 199.9-448.3 448.3S263.6 960.8 512 960.8s448.3-199.9 448.3-448.3C960.2 264.1 760.4 64.2 512 64.2zm280.1 336.2l-297 297c-20.5 20.5-57.9 20.5-78.5 0L231.8 512.5s-28-28 0-56 56 0 56 0l168.1 168.1 280.2-280.2s28-28 56 0 0 56 0 56zm0 0" _fill="#0187f8"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/yesIcon.js